// Platform-aware shortcut labels. The handoff mockups were drawn on a Mac and say ⌘K
// throughout; the owner is on Windows, where ⌘ means nothing (reported 2026-08-26). The
// LISTENER always accepted both (metaKey || ctrlKey) — only the labels lied.
//
// Detection is presentational only: getting it wrong shows the other OS's glyph, nothing
// breaks. `userAgentData.platform` first (navigator.platform is deprecated), then a UA sniff.

type NavigatorUAData = Navigator & { userAgentData?: { platform?: string } }

function detectMac(): boolean {
  if (typeof navigator === 'undefined') return false
  const uaPlatform = (navigator as NavigatorUAData).userAgentData?.platform ?? navigator.platform ?? ''
  if (uaPlatform) return /mac|iphone|ipad|ipod/i.test(uaPlatform)
  return /mac os x/i.test(navigator.userAgent)
}

export const isMac = detectMac()

/** '⌘K' on a Mac, 'Ctrl+K' everywhere else. */
export const modK = isMac ? '⌘K' : 'Ctrl+K'

/** The save-and-open keycap: '⌘⏎' or 'Ctrl+⏎'. */
export const modEnter = isMac ? '⌘⏎' : 'Ctrl+⏎'
